import RocketLaunchOutlined from '@mui/icons-material/RocketLaunchOutlined';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { WButton } from '@wareclouds/wareclouds-ui';
import { useTranslation } from 'react-i18next';

export default function TrainingStartModal({ open, onStart }) {
  const { t } = useTranslation(['onboarding']);

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown={true}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            maxWidth: 400,
            width: '100%',
          },
        },
      }}
    >
      <DialogContent
        sx={{
          textAlign: 'center',
          py: 3,
          px: 3,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <RocketLaunchOutlined
            sx={{ fontSize: 56, color: 'grey.500', mb: 2 }}
          />

          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            sx={{ fontSize: 24, width: '100%' }}
          >
            {t('training.startModal.title')}
          </Typography>

          <Typography
            variant="body1"
            component="span"
            sx={{
              mb: 3,
              color: 'text.primary',
              lineHeight: 1.6,
              width: '100%',
              display: 'block',
            }}
          >
            {t('training.startModal.description')}
          </Typography>

          <WButton
            label={t('training.startModal.button')}
            variant="contained"
            color="primary"
            fullWidth
            onClick={onStart}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
